var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576 435",
    style: {
      enableBackground: "new 0 0 576 435"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M573.4,319.4c0-13.4-6-26.1-16.5-35.1c19.3-17.2,22.2-45.4,6.6-65.8c-31.2-41.8-94.6-68.9-161.7-69 c-67,0.1-130.5,27.2-161.6,69c-15.6,20.3-12.8,48.6,6.6,65.8c-20.2,17.1-22.1,46.5-4.3,65.9c-7.8,7-12.2,16.7-12.2,27 c0,31.9,27.2,57.7,60.8,57.8h221.6c33.5,0,60.7-25.9,60.8-57.8c0-10.2-4.4-20-12.2-27C569.1,341.6,573.4,330.7,573.4,319.4z  M263.6,234.2c23.9-32.1,76.6-57.5,138.3-57.5s114.4,25.4,138.3,57.5c11.8,15.9-0.2,37.7-20.7,37.7H284.3 C263.7,271.8,251.8,250.1,263.6,234.2z M512.7,407.7H291.1c-17.8,0-32.2-13.7-32.2-30.6c0-5.6,4.8-10.2,10.7-10.2l0,0h264.5 c5.9,0,10.7,4.6,10.7,10.2l0,0C544.9,394,530.4,407.7,512.7,407.7z M523.4,339.7h-243c-11.8,0-21.4-9.1-21.4-20.3 s9.6-20.3,21.4-20.3h243c11.8,0,21.4,9.1,21.4,20.3S535.2,339.7,523.4,339.7z M401.9,231c7.9,0,14.3-6.1,14.3-13.6 s-6.4-13.6-14.3-13.6s-14.3,6.1-14.3,13.6C387.6,225,394,231,401.9,231z M473.4,244.6c7.9,0,14.3-6.1,14.3-13.6s-6.4-13.6-14.3-13.6 s-14.3,6.1-14.3,13.6S465.5,244.6,473.4,244.6z M330.4,244.6c7.9,0,14.3-6.1,14.3-13.6s-6.4-13.6-14.3-13.6s-14.3,6.1-14.3,13.6 S322.5,244.6,330.4,244.6z M87.3,407L58.7,135.9H309c3.9,0,7.1-3,7.1-6.8v-13.6c0-3.7-3.2-6.8-7.1-6.8H191.5l21.4-81.6h38.9 c3.9,0,7.1-3,7.1-6.8V6.8c0-3.7-3.2-6.8-7.1-6.8h-38.9c-13.1,0-24.6,8.5-27.8,20.6l-23.1,88H8.7c-3.9,0-7.1,3-7.1,6.8V129 c0,3.7,3.2,6.8,7.1,6.8h21.4v1.4l28.6,272.4c1,14.3,13.5,25.3,28.6,25.2H226c-7.8-7.9-13.9-17.2-18-27.3L87.3,407z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.1c3954d50b25ea9f6d3b2f942142feaf.svg";
export { ForwardRef as ReactComponent };